<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header">Nuevo Area de Trabajo</h5>
                <div class="form-desc">Adición de una nueva area de trabajo</div>
                <div class="row">
                  <div class="col-sm-9 col-md-10">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.nombre && current.errors.nombre.length > 0 }"
                      >Nombre</label>
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{ 'is-invalid': current.errors.nombre && current.errors.nombre.length > 0 }"
                        type="text"
                      >
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small>
                    </div>
                  </div>
                </div>

                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link class="btn btn-default" :to="{ name: 'cat-areas', params: {  }}">
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import AreaService from "@/services/catalogos/AreaService";
import Notifications from "@/notifications/notifications";

export default {
  data() {
    return {
      current: {
        errors: {}
      }
    };
  },

  computed: {},
  mounted() {
    if (this.$route.params.id) {
      AreaService.getById(this.$route.params.id).then(response => {
        this.current = response.data;
        this.current.errors = [];
      });
    }
  },

  methods: {
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, this.current);
      delete current.image;
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
        delete current.id;
      }
      AreaService.save(current)
        .then(res => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Area",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-areas",
            params: { id: self.current.id }
          });
        })
        .catch(error => {
            Vue.nextTick(function() {
              self.current.errors = Object.assign({}, error.response.data);
              console.log(self.current.errors);
            });
        });
    },
    showModal(e) {
      e.preventDefault();
    }
  }
};
</script>
